import { UpgradeIcon } from '../icons'

export const Welcome: React.FC = () => {
	return (
		<section className='welcome'>
			<section className='iframe-container'>
				<iframe
					title='avideo'
					src='https://www.youtube.com/embed/tgbNymZ7vqY'></iframe>
			</section>
			<section className='content'>
				<h1>Welcome Elon Musk</h1>
				<p>
					Before generating creatives that bring results, let’s first see how
					AdCreative.ai works so you can make the most of it.
				</p>
				<div>
					<button>
						<div>
							<UpgradeIcon />
						</div>{' '}
						GET STARTED
					</button>
				</div>
			</section>
		</section>
	)
}
